import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

function TextareaInput(props) {
    const handleChange = useCallback(
        e => props.onChange(e.target.value),
        [props.onChange]
    );

    return (
        <textarea
            {...props}
            className={props.className ? props.className : 'form-control'}
            value={props.value}
            onChange={handleChange}
        />
    );
}

TextareaInput.propTypes = {
    value: PropTypes.string,
    className: PropTypes.string,
    onChange: PropTypes.func.isRequired
};

export default React.memo(TextareaInput);
